<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#9BB3C7" />
    <path
      d="M6 10L14 10"
      stroke="white"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'NotStartedIcon'
}
</script>

<style lang="scss" scoped>
.NotStartedIcon {
}
</style>
